import compose from 'utils/composeEnhancer'
import toggleSidebarStore from 'hooks/toggleSidebarStore'
// import useSiema from 'hooks/useSiema'

export default compose(
  // useSiema,
  toggleSidebarStore
)
